import { render, staticRenderFns } from "./doubtCourseDetail.vue?vue&type=template&id=89e36f94&scoped=true&"
import script from "./doubtCourseDetail.vue?vue&type=script&lang=js&"
export * from "./doubtCourseDetail.vue?vue&type=script&lang=js&"
import style0 from "./doubtCourseDetail.vue?vue&type=style&index=0&id=89e36f94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89e36f94",
  null
  
)

export default component.exports